import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;

// withCredentials so the httpOnly session cookie is sent/received.
export const adminApi = axios.create({ baseURL: API, withCredentials: true, timeout: 15000 });

export const exchangeSession = (session_id) =>
  adminApi.post("/session", { session_id }).then((r) => r.data);

export const fetchMe = () => adminApi.get("/me").then((r) => r.data);

export const logout = () => adminApi.post("/logout").then((r) => r.data);
